module.exports = __webpack_public_path__ + "img/trace_code_feedback.8473b945.png";